import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import I8N from "@eres/core/dist/I8N";
import { TabuVIPCategory } from "@10x/sso/TabuProfile";
import SendMessagePopup from "./SendMessagePopup";
import { JQModal } from "../Popup/Utils";
import { OwnerVIPCategory } from "@eres/vipownerapi/entities";
import { AppConstants } from "../../configApp";

interface Props {
	vipCategory: TabuVIPCategory;
	onNewRequest: () => void;
}

interface State {
	showSendMessage?: boolean;
}

class ContactManager extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		const { vipCategory } = this.props;
		const { showSendMessage } = this.state;
		const mobile = vipCategory.PropertyManagerMobile;
		const phone = vipCategory.PropertyManagerPhone;
		const email = vipCategory.PropertyManagerEmail;
		return <React.Fragment>
			<div className="accordion accordian-style relationship-manager-detail mt-2">
				<div className="card">
					<div>
						<div className="relationship-manager">
							<div className="manager-name">{ I8N.isRTL() ? vipCategory.PropertyManagerNameAr :
								vipCategory.PropertyManagerNameEn }</div>
							<div className="manager-detail">
								<div>
									<span className="icon-call"/>
									<span><a href={ `tel:${ mobile }` }>{ mobile }</a><br/>
                                <small>{ Strings.personal }</small>
                            </span>
								</div>
								<div>
									<span className="icon-call"/>
									<span><a href={ `tel:${ phone }` }>{ phone }</a><br/>
                                <small>{ Strings.office }</small>
                            </span>
								</div>
								<div>
									<span className="icon-email"/>
									<span><a href={ `mailto:${ email }` }>{ email }</a><br/>
                                <small>{ Strings.email }</small>
                            </span>
								</div>
								<div>
									<span className="icon-share"/>
									<span><a href={ getShareAccountManager( vipCategory ) }>
                                        { Strings.share_business_card }</a><br/>
                                <small>{ Strings.personal_information }</small>
                            </span>
								</div>
								<div>
									<span className="icon-message"/>
									<span><a
										onClick={ this.showSendMessage }
										style={ { cursor: "pointer" } }>{ Strings.send_message }</a><br/>
                                <small>{ Strings.for_all_services }</small>
                            </span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{ showSendMessage && <SendMessagePopup onDismiss={ this.hideSendMessage }/> }
		</React.Fragment>;
	}

	private showSendMessage = () => {
		this.setState( { showSendMessage: true }, () => {
			JQModal( "SendMessage" ).show();
		} );
	};

	private hideSendMessage = ( requestNo?: number ) => {
		this.setState( { showSendMessage: false }, () => {
			JQModal( "SendMessage" ).hide();
			if ( requestNo ) {
				this.props.onNewRequest();
			}
		} );
	};
}

export function getOwnerVIPCategory( categoryId: number ) {
	switch ( categoryId ) {
		case OwnerVIPCategory.GOLD:
			return `${ AppConstants.rootUrl }assets/img/VIPOwner/gold.jpg`;
		case OwnerVIPCategory.SILVER:
			return `${ AppConstants.rootUrl }assets/img/VIPOwner/silver.jpg`;
		case OwnerVIPCategory.ROYAL:
			return `${ AppConstants.rootUrl }assets/img/VIPOwner/royal.jpg`;
		case OwnerVIPCategory.DIAMOND:
			return `${ AppConstants.rootUrl }assets/img/VIPOwner/diamond.jpg`;
		case OwnerVIPCategory.PLATINUM:
			return `${ AppConstants.rootUrl }assets/img/VIPOwner/platinum.jpg`;
		default:
			return undefined;
	}
}

export function getOwnerVIPCategoryLabel( categoryId: number ) {
	switch ( categoryId ) {
		case OwnerVIPCategory.GOLD:
			return Strings.gold;
		case OwnerVIPCategory.SILVER:
			return Strings.silver;
		case OwnerVIPCategory.ROYAL:
			return Strings.royal;
		case OwnerVIPCategory.DIAMOND:
			return Strings.diamond;
		case OwnerVIPCategory.PLATINUM:
			return Strings.platinum;
		default:
			return "";
	}
}

function getShareAccountManager( category?: TabuVIPCategory ) {
	if ( category ) {
		const name = I8N.isRTL() ? category.PropertyManagerNameAr : category.PropertyManagerNameEn;
		let info = `${ Strings.name }: ${ name }\n`;
		info += `${ Strings.Mobile_text }: ${ category.PropertyManagerMobile }\n`;
		info += `${ Strings.phone }: ${ category.PropertyManagerPhone }\n`;
		info += `${ Strings.email }: ${ category.PropertyManagerEmail }\n`;
		return `mailto: ?subject=${ Strings.account_manager_details }&body=${ encodeURIComponent( info ) }`;
	}
}

export default ContactManager;
